


































































import { CardOperationNotificationsVueGB } from "@/extensions/cardOperations/CardOperationNotificationsVueGB";
import { Component } from "vue-property-decorator";
import VerifyBox from "@/components/app/VerifyBox.vue";
import BackLink from "@/components/app/BackLink.vue";

@Component({
  components: { VerifyBox, BackLink },
})
export default class CardOperationNotifications extends CardOperationNotificationsVueGB {
  async mounted() {
    await this.loadNotificationData();
  }
}
